import { firestore, firebaseStorage, BADGES_STORAGE_FOLDER } from '../main';

export default {
  namespaced: true,
  state: {
    badges: [],
    availableBadgeIcons: [],
    customBadgesIcons: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    pickedBadgeIcon: null
  },
  mutations: {
    RECEIVED_BADGES(state, payload) {
      state.badges = payload;
      state.isReceiving = false;
    },
    RECEIVED_CUSTOM_BADGES(state, payload) {
      state.customBadgesIcons = payload;
      state.isReceiving = false;
    },
    RECEIVING_BADGES(state) {
      state.isReceiving = true;
    },
    UPDATED_BADGE(state, payload) {
      let index = state.badges.findIndex(p => p.id === payload.id);
      if (index == -1) {
        state.badges = [...state.badges, payload];
      }
      state = Object.assign(state, {
        badges: state.badges.map((p, i) => {
          if (i === index) {
            return Object.assign({}, p, payload);
          }
          return p;
        }),
        isUpdating: false
      });
    },
    UPDATING_BADGE(state) {
      state.isUpdating = true;
    },
    DELETED_BADGE(state, payload) {
      let indexToDelete = state.badges.findIndex(p => p.id === payload.id);
      let badges = [...state.badges];
      badges.splice(indexToDelete, 1);
      state = Object.assign(state, {
        badges: [...badges],
        isDeleting: false,
        idToDelete: null
      });
    },
    DELETING_BADGE(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
    PICK_ICON(state, payload) {
      state.pickedBadgeIcon = payload;
    },
    RECEIVED_AVAILABLE_ICONS(state, payload) {
      state.availableBadgeIcons = payload;
    }
  },
  actions: {
    pickIcon({ commit }, payload) {
      commit('PICK_ICON', payload);
    },
    async getAvailableBadgeIcons({ dispatch }) {
      const snapshot = await firestore.collection('badge_icons').get();
      const icons = snapshot.docs.map(doc => Object.assign({}, doc.data(), { id: doc.id }));
      dispatch('receiveAvailableIcons', icons);
    },
    async getAvailableCustomBadgeIcons({ dispatch }, tenantId) {
      const snapshot = await firebaseStorage.child(`${BADGES_STORAGE_FOLDER}/${tenantId}/`).listAll();

      const icons = await Promise.all(
        snapshot.items.map(async doc => Object.assign({}, { downloadUrl: await doc.getDownloadURL() }, { id: doc.name }))
      );
      dispatch('receiveAvailableCustomBadgeIcons', icons);
    },
    async deleteBadgeFile({ dispatch }, payload) {
      var imagePath = firebaseStorage.child(`${BADGES_STORAGE_FOLDER}/${payload.tenantId}/${payload.fileId}`);
      await imagePath.delete();
    },
    async uploadBadgeFile({ dispatch }, payload) {
      const uid = Math.floor(Math.random() * 10000000);
      const ext = payload.file.name.substr(payload.file.name.lastIndexOf('.'));
      const fileId = `${uid}${ext}`;

      var imagePath = firebaseStorage.child(`${BADGES_STORAGE_FOLDER}/${payload.tenantId}/${fileId}`);
      await imagePath.put(payload.file);
      const downloadUrl = await imagePath.getDownloadURL();
      return { id: fileId, downloadUrl: downloadUrl };
    },
    async getBadgesRequest({ dispatch }, selectedCountry) {
      dispatch('receivingBadges');
      const snapshot = await firestore
        .collection('badges')
        .where('tenantId', '==', selectedCountry)
        .get();
      const snapshotGlobal = await firestore
        .collection('badges')
        .where('global', '==', true)
        .get();
      let badges = snapshot.docs.map(doc => Object.assign({}, doc.data(), { id: doc.id }));
      snapshotGlobal.docs.forEach(doc => badges.push(Object.assign({}, doc.data(), { id: doc.id })));
      for (let i in badges) {
        let badge = badges[i];
        const referencedBehavioursSnapshot = await firestore
          .collection('behaviours')
          .where('badgeIds', 'array-contains', badge.id)
          .get();
        if (referencedBehavioursSnapshot.docs.length > 0) {
          badge.isAssociatedWithBehaviours = true;
        } else {
          badge.isAssociatedWithBehaviours = false;
        }
      }
      dispatch('receiveBadges', badges);
    },
    async updateBadgeRequest({ dispatch }, payload) {
      dispatch('updatingBadge');
      console.log('BADGE ACI2', payload.badge);

      const badgeRef = await firestore
        .collection('badges')
        .doc(payload.id)
        .set(payload.badge, { merge: true });
      payload.$toasted.success('Badge has been updated!');
      dispatch('updateBadge', payload.badge);
    },
    async createBadgeRequest({ dispatch }, payload) {
      dispatch('updatingBadge');
      const badgeRef = await firestore.collection('badges').add(payload.badge);
      const badgeSnapshot = await firestore
        .collection('badges')
        .doc(badgeRef.id)
        .get();
      payload.$toasted.success('Badge has been created!');
      dispatch('updateBadge', Object.assign({}, badgeSnapshot.data(), { id: badgeRef.id }));
    },
    async deleteBadgeRequest({ dispatch }, payload) {
      dispatch('deletingBadge', payload);
      console.error('DELETING BADGE');
      if (payload.badge.id != null) {
        await firestore
          .collection('badges')
          .doc(payload.badge.id)
          .delete();
        // var imagePath = firebaseStorage.child(`${BADGES_STORAGE_FOLDER}/${payload.badge.tenantId}/${payload.badge.fileId}`);
        // await imagePath.delete();
        dispatch('deleteBadge', { id: payload.badge.id });
        payload.$toasted.success('Badge has been deleted!');
      } else {
        dispatch('deleteBadge', {});
        payload.$toasted.error('Badge could not be deleted!');
      }
    },
    receiveAvailableCustomBadgeIcons({ commit }, payload) {
      commit('RECEIVED_CUSTOM_BADGES', payload);
    },
    receiveBadges({ commit }, payload) {
      commit('RECEIVED_BADGES', payload);
    },
    receivingBadges({ commit }) {
      commit('RECEIVING_BADGES');
    },
    updateBadge({ commit }, payload) {
      commit('UPDATED_BADGE', payload);
    },
    updatingBadge({ commit }) {
      commit('UPDATING_BADGE');
    },
    deleteBadge({ commit }, payload) {
      commit('DELETED_BADGE', payload);
    },
    deletingBadge({ commit }, payload) {
      commit('DELETING_BADGE', payload);
    },
    receiveAvailableIcons({ commit }, payload) {
      commit('RECEIVED_AVAILABLE_ICONS', payload);
    }
  }
};
